import { DesignFormParameterDto } from "./designFormParameterDto";

export class FormVorlageDto {
	public formId: number = 0;
	public name: string = "";
	public description: string = "";
	public text: string = "";
	public stanzwerkzeugId: string = "";
	public featureType: number = 0;
	public parameters: Array<DesignFormParameterDto> = new Array<DesignFormParameterDto>();
	public isActive: boolean = false;
}
